import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IReportEmbedConfiguration } from 'powerbi-client';
import { InputTextModule } from 'primeng/inputtext';
import { BehaviorSubject, concatMap, distinctUntilChanged, filter, switchMap, timer } from 'rxjs';

import { urlValidator } from '../../../../../shared/utils/validation/url-validator';
import { PowerBiWidgetConfiguration } from '../../../models/powerbi-widget.model';
import {
  WidgetConfigurationComponent,
  WidgetConfigurationType,
} from '../../../models/widget-configuration.model';
import { PowerbiService } from '../powerbi-widget/powerbi.service';

@Component({
  selector: 'carehub-powerbi-widget-configuration',
  imports: [InputTextModule, ReactiveFormsModule],
  templateUrl: './powerbi-widget-configuration.component.html',
  styleUrl: './powerbi-widget-configuration.component.scss',
})
export class PowerBiWidgetConfigurationComponent implements WidgetConfigurationComponent, OnInit {
  @Input() initialConfigurationuration?: PowerBiWidgetConfiguration;
  @Input() powerbiConfig: IReportEmbedConfiguration | undefined;
  @Output() powerbiConfigChange = new EventEmitter<IReportEmbedConfiguration>();

  configForm: FormGroup;
  url$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(
    private formBuilder: FormBuilder,
    private powerBiService: PowerbiService
  ) {
    this.configForm = this.formBuilder.group({
      header: ['', Validators.required],
      url: ['', [urlValidator, Validators.pattern(this.powerBiService.regex)]],
    });

    this.url$
      .pipe(
        filter(url => url !== null && url !== undefined && url.length > 0),
        distinctUntilChanged(),
        takeUntilDestroyed(),
        switchMap(url =>
          timer(0, 1000 * 60 * 60).pipe(concatMap(() => this.powerBiService.getPowerBiEmbed(url)))
        )
      )
      .subscribe((config) => {
        this.powerbiConfig = config;
        this.powerbiConfigChange.emit(config);
      });
  }

  ngOnInit(): void {
    if (this.initialConfigurationuration) {
      this.configForm.patchValue(this.initialConfigurationuration);
      const powerBiConfig: PowerBiWidgetConfiguration = this.initialConfigurationuration;
      if (powerBiConfig.url) {
        this.url$.next(powerBiConfig.url);
      }
    }
  }

  isValid(): boolean {
    return this.configForm.valid;
  }

  getConfiguration(): WidgetConfigurationType {
    return this.configForm.value as PowerBiWidgetConfiguration;
  }
}
